import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

/** Sentinel for "no filter applied" — a Radix SelectItem cannot hold an empty value. */
export const ALL_FILTER_VALUE = "all";

export interface AuditFilterOption {
  value: string;
  label: string;
}

interface AuditFilterSelectProps {
  /** Shown in the trigger before anything is chosen, e.g. "Stage". */
  placeholder: string;
  /** Label of the unfiltered option, e.g. "All Stages". */
  allLabel: string;
  value: string;
  options: AuditFilterOption[];
  onChange: (value: string) => void;
}

/** One filter dropdown in the audit history toolbar; they differ only in their options. */
export const AuditFilterSelect = ({
  placeholder,
  allLabel,
  value,
  options,
  onChange,
}: AuditFilterSelectProps) => (
  <Select value={value} onValueChange={onChange}>
    <SelectTrigger className="w-[180px]">
      <SelectValue placeholder={placeholder} />
    </SelectTrigger>
    <SelectContent>
      <SelectItem value={ALL_FILTER_VALUE}>{allLabel}</SelectItem>
      {options.map((option) => (
        <SelectItem key={option.value} value={option.value}>
          {option.label}
        </SelectItem>
      ))}
    </SelectContent>
  </Select>
);
